const getDocumentCategory = (category) => {
  return category
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/turbo tenant/gi, 'TurboTenant');
};

export default getDocumentCategory;
